import { Row as ReactTableRow } from '@tanstack/react-table';

import { isPinned } from './isPinned.ts';

export function getPinnedRowSortingOrder<T>(
  rowA: ReactTableRow<T>,
  rowB: ReactTableRow<T>,
  isSortedDesc: boolean,
  shouldPinFirstRow: boolean | number,
): number {
  const pinnedA = isPinned(shouldPinFirstRow, Number(rowA.id));
  const pinnedB = isPinned(shouldPinFirstRow, Number(rowB.id));
  if (pinnedA && !pinnedB) {
    return isSortedDesc ? 1 : -1;
  }
  if (!pinnedA && pinnedB) {
    return isSortedDesc ? -1 : 1;
  }
  return 0;
}
